import React from "react";
import StackComponent from "../../components/Base/StackComponent";
import styled from "@emotion/styled";
import copyright from "./../../assets/icons/common/copyright.png";
import ImageComponent from "../../components/Base/ImageComponent";
import TypographyComponent from "../../components/Base/TypographyComponent";
import FooterContent from "./FooterContent";
import { SECTION_MARGIN } from "../../config/constants";
import { useResponsive } from "../../hooks";

const Container = styled(StackComponent)(({ theme, responsiveMargin }) => ({
  paddingTop: "150px",
  paddingLeft: responsiveMargin,
  paddingRight: responsiveMargin,
  width: "100%",
}));

const Footer = () => {
  const { isMediumScreen, isSmallScreen, isExtraSmallScreen } = useResponsive();
  const PADDING_X = isSmallScreen ? "20px" : SECTION_MARGIN;
  return (
    <Container responsiveMargin={PADDING_X} direction="column">
      <FooterContent />
      <StackComponent
        spacing="6px"
        alignItems="center"
        justifyContent="center"
        sx={{
          height: "92px",
          borderTop: "1px solid rgba(20, 24, 62, 0.15)",
          width: "100%",
          marginTop: "83px",
        }}
      >
        <ImageComponent width="16px" height="16px" source={copyright} />
        <TypographyComponent sx={{ color: "#78847D" }} variant="totalLabel">
          Copyright JobTask. All right reserved
        </TypographyComponent>
      </StackComponent>
    </Container>
  );
};

export default Footer;
